import React, { CSSProperties } from "react";
import SkeletonDetails from "../../styles/components/SkeletonDetails";

interface Props {
  width?: string;
  height?: string;
  style?: CSSProperties;
  className?: string;
}

const Skeleton = ({ width, height, style, className }: Props) => {
  return (
    <SkeletonDetails
      className={className}
      style={{ ...style }}
      $width={width}
      $height={height}
    />
  );
};

export default Skeleton;
